import rankingData from "@/data/ranking_pages.json";
import { DISPLAY_NAME, STAGE_LABEL } from "@/lib/ranking-display-names";

/**
 * Homepage index of every ranking list page. Derived from the same data file
 * that drives /lists, so the homepage cannot drift from the list pages.
 */

const STAGE_ORDER = ["Seed", "Early Stage", "Later Stage", "PE"] as const;

const STAGE_PHRASE: Record<string, string> = {
  Seed: "Seed",
  "Early Stage": "Early Stage",
  "Later Stage": "Later Stage",
  PE: "private equity",
};


export type StageChip = {
  slug: string;
  label: string;
  fullName: string;
};

export type IndexRow = {
  category: string;
  name: string;
  chips: StageChip[];
};

function buildRows(dimension: string): IndexRow[] {
  const byCategory = new Map<string, IndexRow>();

  for (const page of rankingData.pages) {
    if (page.dimension !== dimension) continue;
    const name = DISPLAY_NAME[page.category] ?? page.category;
    const row = byCategory.get(page.category) ?? { category: page.category, name, chips: [] };
    row.chips.push({
      slug: page.slug,
      label: STAGE_LABEL[page.stage] ?? page.stage,
      fullName: `Top ${STAGE_PHRASE[page.stage] ?? page.stage} investors in ${name}`,
    });
    byCategory.set(page.category, row);
  }

  const rows = [...byCategory.values()];
  for (const row of rows) {
    row.chips.sort(
      (a, b) =>
        STAGE_ORDER.indexOf(a.label === "Private Equity" ? "PE" : (a.label as "Seed")) -
        STAGE_ORDER.indexOf(b.label === "Private Equity" ? "PE" : (b.label as "Seed")),
    );
  }
  return rows.sort((a, b) => a.name.localeCompare(b.name));
}

export const VERTICAL_ROWS = buildRows("Vertical");
export const COMPANY_TYPE_ROWS = buildRows("Company Type");

export const TOTAL_LIST_COUNT = rankingData.pages.length;
